import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import { Colors } from "chart.js";
ChartJS.register(ArcElement, Tooltip, Legend, Colors);

const PieChartOne = ({ dateChart, data, setStoreTotal, setVanTotal }) => {
  const labels = ["cash", "CashApp", "Zelle", "Paypal", "Card"];
  var xcash = 0;
  var xcashApp = 0;
  var xzelle = 0;
  var xother = 0;
  var xcard = 0;
  var storeTot = 0;
  var vanTot = 0;
  data.map((x) => {
    xcash = xcash + Number(x.cash);
    xcashApp = xcashApp + Number(x.cashApp);
    xzelle = xzelle + Number(x.zelle);
    xother = xother + Number(x.other);
    xcard = xcard + Number(x.card);
    if (x.location === "store") {
      storeTot =
        storeTot +
        (Number(x.cash) +
          Number(x.cashApp) +
          Number(x.zelle) +
          Number(x.other) +
          Number(x.card));
    }
    if (x.location === "van") {
      vanTot =
        vanTot +
        (Number(x.cash) +
          Number(x.cashApp) +
          Number(x.zelle) +
          Number(x.other) +
          Number(x.card));
    }
    return 0;
  });
  setStoreTotal(storeTot);
  setVanTotal(vanTot);

  const data1 = {
    labels: labels,
    datasets: [
      {
        type: "pie",
        label: "%",
        data: [xcash, xcashApp, xzelle, xother, xcard],
        fill: false,

        tension: 0.1,
        hoverOffset: 4,
      },
    ],
  };

  return (
    <div>
      <Grid>
        <Box>
          <Typography variant="caption">
            Break Even Point {dateChart}
          </Typography>
        </Box>
        <Box>
          <Pie
            height={280}
            width={"95%"}
            data={data1}
            options={{
              maintainAspectRatio: false,
              lugins: {
                colors: {
                  enabled: false,
                },
              },
            }}
          />
        </Box>
      </Grid>
    </div>
  );
};

export default PieChartOne;
